import { Bleedable } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import { MARGIN_Y_DEFAULT } from './common'
import useMergeMarginX from './useMergeMarginX'

type Props = {
  children: ReactNode
}

export default function MergeSquareCardMarginBox({ children }: Props): JSX.Element {
  return (
    <Bleedable sides={useMergeMarginX()} top={MARGIN_Y_DEFAULT} bottom={MARGIN_Y_DEFAULT}>
      {children}
    </Bleedable>
  )
}
